import {
  Cross,
  Baby,
  HeartPulse,
  TreePine,
  Droplet,
  Users,
  Wind,
  Bandage,
  Activity,
  Stethoscope,
  Award,
  ShieldCheck,
} from "lucide-react";
import { Reveal } from "./motion";
import { HSI_PROGRAMS } from "../data/site";

const ICONS = {
  Cross,
  Baby,
  HeartPulse,
  TreePine,
  Droplet,
  Users,
  Wind,
  Bandage,
  Activity,
  Stethoscope,
};

export const Programs = () => {
  return (
    <section
      className="py-24 lg:py-28 bg-white border-y border-slate-200"
      data-testid="programs-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-[#D1FAE5]/60 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-teal">
                <Award className="h-4 w-4" />
                HSI Authorized Instructor
              </span>
              <h2 className="mt-6 font-editorial font-black text-navy tracking-tight leading-[1.03] text-4xl sm:text-5xl">
                Authorized training programs
              </h2>
              <p className="mt-6 font-body text-lg text-slate-600 leading-relaxed">
                As an HSI-authorized instructor, Second Chance CPR is qualified
                to deliver the following training programs and issue
                certification materials for each completed course.
              </p>
              <div
                className="mt-8 flex items-start gap-3 rounded-2xl border border-emerald-100 bg-[#D1FAE5]/50 p-5"
                data-testid="certification-note"
              >
                <ShieldCheck className="h-6 w-6 text-teal shrink-0 mt-0.5" />
                <div>
                  <p className="font-grotesk font-bold text-navy">
                    Certification Materials Included
                  </p>
                  <p className="mt-1 font-body text-[15px] text-slate-600 leading-relaxed">
                    Certification materials are issued for each program upon
                    successful completion.
                  </p>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {HSI_PROGRAMS.map((p, i) => {
                  const Icon = ICONS[p.icon] || Activity;
                  return (
                    <li
                      key={p.name}
                      className="group flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4 sm:p-5 transition-all duration-300 hover:-translate-y-0.5 hover:border-teal/40 hover:ambient-shadow"
                      data-testid={`program-${i}`}
                    >
                      <span className="grid place-items-center h-11 w-11 rounded-xl bg-red-accent/10 text-red-accent shrink-0">
                        <Icon className="h-5 w-5" strokeWidth={1.75} />
                      </span>
                      <span className="font-grotesk font-bold text-navy text-[15px] sm:text-base leading-tight">
                        {p.name}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
